import { connect } from 'react-redux';
import { onRestart, onRetry, onCloseCompletedDialog } from '../../../reducers/course.reducers';
import Dialog from './course-completed';
import {
  selectTest,
  onStartTest,
  onSetActiveTestRun,
} from '../../../reducers/test.reducers';

const mapStateToProps = state => ({
  open: state.courses.completedDialogOpen,
  cardsCount: state.courses.currentCards.length,
  course: state.courses.selectedCourse,
  cardsNotKnownCount: state.courses.cardsNotKnown.length,
  testRuns: state.tests.testRuns,
});

const mapDispatchToProps = dispatch => ({
  onRestart: () => dispatch(onRestart()),
  onRetry: () => dispatch(onRetry()),
  close: () => dispatch(onCloseCompletedDialog()),
  startNewTestRun: (test) => {
    dispatch(selectTest(test));
    dispatch(onStartTest({ testId: test.id }));
  },
  loadTest: test => dispatch(selectTest(test)),
  setTestRun: run => dispatch(onSetActiveTestRun(run)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dialog);



// WEBPACK FOOTER //
// ./src/app/main/dialogs/course-completed/course-completed.container.js